import Vue from 'vue'
import VueRouter from 'vue-router'
import SignIn from '../views/SignIn.vue'
import AuthPasswordChange from '../views/AuthPasswordChange.vue'
import Msi from '../views/MSI/index.vue'
import SignUp from '../views/MSI/SignUp.vue'
import PasswordRecovery from '../views/PasswordRecovery/index.vue'
import NotFound from '../views/NotFound.vue';
import Profile from '../views/Profile.vue';
import Bid from '../views/Bid.vue';
import Main from '../views/Main.vue';
import Cards from '../views/Cards/Cards.vue';
import Settings from '../views/Settings/index.vue';
import Archive from '../views/Archive/index.vue';
import Notifications from '../views/Notifications.vue';
import Messages from '../views/Messages.vue';
import Contract from '../views/Contract/Contract.vue';
import Contacts from '../views/StaticPages/Contacts.vue';
import Legislation from '../views/StaticPages/Legislation.vue';
import GetLoan from '../views/StaticPages/GetLoan.vue';
import Investing from '../views/StaticPages/Investing.vue';
import Questions from '../views/StaticPages/Questions/index.vue';
import About from '../views/StaticPages/About.vue';
import Arbitration from '../views/StaticPages/Arbitration.vue';
import ChangePassword from '../views/Settings/ChangePassword.vue';
import ChangeContactInfo from '../views/Settings/ChangeContactInfo.vue';
import ChangeWorkInfo from '../views/Settings/ChangeWorkInfo/ChangeWorkInfo.vue';
import EditWorkInfoBorrower from '../views/Settings/ChangeWorkInfo/EditWorkInfoBorrower.vue';
import EditWorkInfoLender from '../views/Settings/ChangeWorkInfo/EditWorkInfoLender.vue';
import ChangePersonalDataAgreement from '../views/Settings/PersonalDataAgreement/ChangePersonalDataAgreement.vue';
import SignPersonalDataAgreement from '../views/Settings/PersonalDataAgreement/SignAgreement.vue';
import ActualMsiInfo from '../views/Settings/actualMsiInfo/actualMsiInfo.vue';
import ScoringAgreement from '../views/ScoringAgreement/index.vue';
import Loan from '../views/Profile/Loan.vue';
import Documents from '../views/StaticPages/Documents.vue';
import News from '../views/News/index.vue';
import DocumentsActive from '../views/StaticPages/Documents/Active.vue';
import DocumentsArchive from '../views/StaticPages/Documents/Archive.vue';
import DocumentsPending from '../views/StaticPages/Documents/Pending.vue';
import SignClaim from '../views/Claim/SignClaim.vue';
import SignLawsuit from '../views/Lawsuit/SignLawsuit.vue';
import SignEarlyRepaymentNotify from '../views/EarlyRepayment/SignEarlyRepaymentNotify.vue';

Vue.use(VueRouter)

const routes = [  {
    path: '/signIn',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/auth-password-change',
    name: 'auth-password-change',
    component: AuthPasswordChange
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/sign-claim/:id',
    name: 'sign-claim',
    component: SignClaim,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/lawsuit-sign/:id',
    name: 'lawsuit-sign',
    component: SignLawsuit,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/sign-early-repayment/:id',
    name: 'sign-early-repayment',
    component: SignEarlyRepaymentNotify,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/loan/:id',
    name: 'loan',
    component: Loan,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
    children: [
      {
        path: '',
        redirect: { name: 'documentsActive' }
      },
      {
        path: 'active',
        name: 'documentsActive',
        component: DocumentsActive
      },
      {
        path: 'archive',
        name: 'documentsArchive',
        component: DocumentsArchive
      },
      {
        path: 'pending',
        name: 'documentsPending',
        component: DocumentsPending
      }
    ]
  },
  {
    path: '/arbitration',
    name: 'arbitration',
    component: Arbitration
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/questions',
    name: 'questions',
    component: Questions
  },
  {
    path: '/investing',
    name: 'investing',
    component: Investing
  },
  {
    path: '/get-loan',
    name: 'getLoan',
    component: GetLoan
  },
  {
    path: '/legislation',
    name: 'legislation',
    component: Legislation
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: Contacts
  },
  {
    path: '/',
    name: 'main',
    component: Main
  },
  {
    path: '/scoring-agreement',
    name: 'scoringAgreement',
    component: ScoringAgreement,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/contract',
    name: 'contract',
    component: Contract,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/messages',
    name: 'messages',
    component: Messages,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/archive',
    name: 'archive',
    component: Archive,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: ChangePassword,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/change-contact-info',
    name: 'change-contact-info',
    component: ChangeContactInfo,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/change-work-info',
    name: 'change-work-info',
    component: ChangeWorkInfo,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/edit-work-info-borrower',
    name: 'edit-work-info-borrower',
    component: EditWorkInfoBorrower,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/edit-work-info-lender',
    name: 'edit-work-info-lender',
    component: EditWorkInfoLender,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/change-personal-data-agreement',
    name: 'change-personal-data-agreement',
    component: ChangePersonalDataAgreement,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/sign-personal-data-agreement',
    name: 'sign-personal-data-agreement',
    component: SignPersonalDataAgreement,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/actual-info',
    name: 'actual-info',
    component: ActualMsiInfo,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/cards',
    name: 'cards',
    component: Cards,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/bid',
    name: 'bid',
    component: Bid,
    meta: {
      isGuarded: true
    }
  },
  {
    path: '/passwordRecovery',
    name: 'PasswordRecovery',
    component: PasswordRecovery
  },
  {
    path: '/msi',
    name: 'msi',
    component: Msi
  },
  {
    path: '/msiinfo',
    name: 'SignUp',
    component: SignUp
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/main',
    redirect: '/'
  },
  {
    path: '*',
    redirect: '/404'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  //eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const isAuth = !!token;

  function guardRoute(to, from, next, isAuth) {
    return isAuth ? next() : next({ name: 'NotFound' });
  }

  if (to.meta.isGuarded) return guardRoute(to, from, next, isAuth);

  next();
});

export default router
